<template>
    <v-app-bar
        color="white"
    >
        <v-toolbar-title>Media Manager</v-toolbar-title>

        <v-spacer></v-spacer>

        <input
            ref="fileInput"
            class="d-none"
            type="file"
            @change="uploadFile($event.target.name, $event.target.files)"
        >

        <v-btn v-if="hasBackButton" class="mx-2" @click="$emit('load-folder', '\\');">
            <v-icon>mdi-arrow-left</v-icon>
            Inapoi
        </v-btn>

        <v-btn class="mx-2" @click="openModalCreateFolder()">
            <v-icon>mdi-folder-plus</v-icon>
            Adaugare director
        </v-btn>

        <v-btn class="mx-2" @click="refresh()">
            <v-icon>mdi-refresh</v-icon>
            Refresh
        </v-btn>

        <v-btn class="mx-2" v-if="hasRole('admin')" :disabled="!isFile(currentFile)" @click="openModalMoveItem()">
            <v-icon>mdi-cursor-move</v-icon>
            Mutare
        </v-btn>

        <v-btn class="mx-2" v-if="hasRole('admin')" :disabled="!isFile(currentFile)" @click="openModalDeleteItem()">
            <v-icon>mdi-delete</v-icon>
            Stergere
        </v-btn>

        <v-btn class="mx-2" v-if="hasRole('admin')" :disabled="!isFile(currentFile)" @click="openModalRenameItem()">
            <v-icon>mdi-rename-box</v-icon>
            Redenumire
        </v-btn>
    </v-app-bar>
</template>

<script>
    import TopToolBar from "../../../../packages/media-manager/js/components/subcomponents/TopToolBar";
    import ACL from "Mixins/acl";
    export default {
        extends: TopToolBar,
        mixins: [ACL],
        computed: {
            hasBackButton() {
                return this.currentPath && this.currentPath.length > 1
            }
        }
    }
</script>
